import './src/vaadin-vertical-layout.js';
export * from './src/vaadin-vertical-layout.js';
